"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toError = void 0;
const common_1 = require("@wix/wix-vod-shared/common");
const transport_error_1 = require("./transport-error");
function toError(error) {
    var _a;
    const errorResponse = error.response;
    const { status, statusText: message, data = {} } = errorResponse;
    const url = (_a = error.config) === null || _a === void 0 ? void 0 : _a.url;
    const camelCasedData = (0, common_1.keysToCamelCase)(data);
    const { errorCode, errorDescription } = camelCasedData;
    return Promise.reject(new transport_error_1.TransportError(status, url, {
        code: errorCode,
        data: camelCasedData,
        message: errorDescription || message,
    }));
}
exports.toError = toError;
//# sourceMappingURL=to-error.js.map